import { AuthenticationProvider } from "@libs/acp/contexts/Authentication";
import { PartnerAuthenticationProvider } from "@libs/acp/contexts/PartnerAuthentication";
import { AdsProvider } from "@libs/ads";
import { WebBridgeProvider } from "@libs/app-bridge";
import { SHProvider } from "@libs/creditkit";
import { DogxProvider } from "@libs/dogx";
import { RedlineProvider } from "@libs/redline";
import { RenegQueryProvider } from "@libs/renegkit";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { createElement } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { setIdentityBaseURL } from "@libs/acp/services/identity/config";
import handlePreloadError from "@libs/utils/helpers/handlePreloadError";
import { config, getBrand } from "@shared/services/brandConfig";
import { identityApi } from "@shared/services/identity-api";
import { persistConfig, queryClient } from "@shared/services/queryClient";
import RedlineService from "@shared/services/redline";
import { App } from "./App";

setIdentityBaseURL(config.identityAPIBaseURL);

RedlineService.start();

window.addEventListener("vite:preloadError", handlePreloadError);

const isRenderInPartner = window !== window.parent;

createRoot(document.getElementById("root")!).render(
	<RenegQueryProvider>
		<PersistQueryClientProvider
			client={queryClient}
			persistOptions={{ ...persistConfig }}
		>
			<RedlineProvider
				instance={RedlineService.getInstance()}
				appName={RedlineService.getAppName()}
			>
				<WebBridgeProvider apiInstance={identityApi} brand={getBrand()}>
					{isRenderInPartner ? (
						<BrowserRouter>
							<PartnerAuthenticationProvider>
								{createElement(App)}
							</PartnerAuthenticationProvider>
						</BrowserRouter>
					) : (
						<DogxProvider>
							<SHProvider
								appName={config.acpAppName}
								mode={import.meta.env.VITE_ENV}
								shKey={config.shKey}
								baseURL={import.meta.env.VITE_SORTING_HAT_API_URL}
								identifier="userDocument"
							>
								<BrowserRouter>
									<AuthenticationProvider>
										<AdsProvider>{createElement(App)}</AdsProvider>
									</AuthenticationProvider>
								</BrowserRouter>
							</SHProvider>
						</DogxProvider>
					)}
				</WebBridgeProvider>
			</RedlineProvider>
		</PersistQueryClientProvider>
	</RenegQueryProvider>,
);
